import ComponentTable from "./ComponentTable";

export default ComponentTable;